import {useInfiniteQuery } from "react-query";
import API from "../../../services/API/Social";

export default function useGetPosts(queryKey){

    const search = queryKey[1];
    const tag = queryKey[2];
    const filter = queryKey[3];
    const id = queryKey[4];
    const courseId = queryKey[5];

    return useInfiniteQuery({
        queryKey,
        queryFn: ({ pageParam = 1 }) => API.getPosts(filter, id, pageParam, search, tag?.id, courseId)
            .then(r => r.data),
        getNextPageParam: (lastPage) => lastPage.meta.hasNextPage ? lastPage.meta.nextPage : undefined,
    })
}